/* eslint-disable react/no-unused-state */
import * as bankTransferFormSchema from 'schemas/forms/BankTransferForm'
import Heading from 'components/Heading'
import Modal from 'components/Modal'
import { validateAll } from 'utils/validators'
import React, { PropTypes, Component } from 'react'
import SelectInput from 'components/Form/components/SelectInput'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/Form/components/TextInput'
import Alert from 'components/Alert'
import styles from './BankTransferDisplayForm.scss'
import constants from 'constants'
import { AtoForm, BankAccountForm, ChequeForm, InternalDttForm, OverseasForm } from './components/BankTransfer'
// import moment from 'moment'
import { format } from 'date-fns'

import {
  formUpdate,
  formInit,
  formSubmit,
  formReset,
} from 'actions/forms'
import BankTransferList from './components/BankTransfer/BankTransfersList'
import BankToAccountList from './components/BankTransfer/BankToAccountList'

class BankTransferDisplayForm extends Component {
  static propTypes = {
    accountsAndLoans: PropTypes.object,
    bankTransferForm: PropTypes.object,
    completeText: PropTypes.string,
    confirmation: PropTypes.bool,
    ctaText: PropTypes.string,
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    handleBankBSB: PropTypes.func,
    handleFormSubmit: PropTypes.func,
    handleSubmit: PropTypes.func.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    show: PropTypes.bool,
    submittingText: PropTypes.string,
    title: PropTypes.string,
  }
  static defaultProps = {
    data: {},
    ctaText: 'Submit',
    completeText: 'Submitted',
    submittingText: 'Submitting',
    show: false,
    confirmation: false,
    description: '',
    handleFormSubmit: null,
    handleBankBSB: null,
    id: '',
    title: '',
    accountsAndLoans: null,
    bankTransferForm: null,
  }
  constructor(props) {
    super(props)
    this.state = {
      toAccountSelected: '',
      fromAccountSelected: '',
      searchBank: '',
      typing: false,
      typingTimeout: 0,
    }
  }

  componentWillMount() {
    const { formFields } = bankTransferFormSchema

    const formData = {
      formFields,
      data: this.props.data || null,
    }

    this.props.dispatch(formInit(this.props.id, formData))
  }

  componentWillReceiveProps(nextProps) {
    const modalCreated = this.props.modals.bankTransferForm
    const modalChanged = modalCreated && nextProps.modals.bankTransferForm.show !== this.props.modals.bankTransferForm.show
    const modalNotVisible = modalCreated && !nextProps.modals.bankTransferForm.show
    const modalVisible = modalCreated && nextProps.modals.bankTransferForm.show
    // const dataChanged = nextProps.data !== this.props.data

    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }

    if (modalChanged && modalVisible) {
      this.setState({ toAccountSelected: '' })
      this.setState({ fromAccountSelected: '' })
      this.props.handleBankBSB('INIT')
      // preload data from BED if needed
    }
  }

  _schema = () => {
    const obj = {}
    bankTransferFormSchema.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  _hide = () => {
    this.props.hide(this.props.id)
    this.props.dispatch(formReset(this.props.id))
  }

  _handleSubmit = (e) => {
    const { accountsAndLoans, bankTransferForm, id } = this.props
    e.preventDefault()
    const values = this.props.forms[this.props.id]
    const data = {}
    Object.keys(values).forEach((key) => {
      if (key.indexOf('_') < 0) {
        data[key] = values[key].value
      }
    })

    // Validate all the forms fields and return any errors
    const errors = validateAll(bankTransferFormSchema.requiredFields, this.props.forms[this.props.id])

    // Check if form has errors
    if (errors.length > 0) {
      // If form has errors handle them
      errors.forEach((errObj) => {
        this._handleError(errObj, errObj.name)
      })
    } else {
      // If form has no errors, pass the serialized form field for submit and set the form to submit.
      // append or map existing data
      data.partnerName = accountsAndLoans.bankTransferAccounts[0].partnerName
      data.transferrequesttype = this.state.toAccountSelected
      data.fromAPVendor = data.fromAccount
      if (this.state.toAccountSelected === constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.ATO) {
        data.bankBSB = constants.ACCOUNTSANDLOANS.ATOPAYMENTFORM.BANK_BSB
        data.bankAccountNo = constants.ACCOUNTSANDLOANS.ATOPAYMENTFORM.BANK_ACCOUNT_NO
      }
      if (this.state.toAccountSelected === constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.BANK) {
        data.bankAccountNo = data.toAccountNumber
        data.bankName = (bankTransferForm.fetched ? bankTransferForm.bankDetail.BankName : '')
        data.bankAddress = (bankTransferForm.fetched ? bankTransferForm.bankDetail.BankAddress : '')
        data.bankCity = (bankTransferForm.fetched ? bankTransferForm.bankDetail.BankCity : '')
        data.bankState = (bankTransferForm.fetched ? bankTransferForm.bankDetail.BankState : '')
        data.bankCountry = (bankTransferForm.fetched ? bankTransferForm.bankDetail.BankCountry : '')
        data.bankZip = (bankTransferForm.fetched ? bankTransferForm.bankDetail.BankZip : '')
      }
      if (this.state.toAccountSelected === constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.CHEQUE) {
        data.toAccountName = data.payee
      }
      if (this.state.toAccountSelected === constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.INTERNAL) {
        // const toAccountNumber = accountsAndLoans.bankTransferAccounts.find(item => item.accountNo === data.fromAccount).legalName.toString()
        // const toAccountNumber = accountsAndLoans.bankTransferAccounts.find(item => item.accountNo === data.toAccountName).partnerName.toString()
        data.bankAccountNo = data.account
        data.toAccountName = data.partnerName
      }
      if (this.state.toAccountSelected === constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.OVERSEAS) {
        data.bankAccountNo = data.toAccountNumber
      }
      this.props.dispatch(formSubmit(id))
      this.props.handleSubmit(data)
    }
  }

  // Takes an error object for a field and updates the state accordingly
  _handleError(errorObj, stateKey) {
    // Set new state value for field and update state
    const stateValue = {
      data: {
        focus: false,
        error: (errorObj.valid) ? '' : errorObj.error,
        valid: errorObj.valid,
      },
      field: stateKey,
    }
    this._handleState(stateValue)
  }

  _handleState = (stateValue) => {
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleAutoComplete = (name, value) => {
    this._handleChange(name, value)
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    if (name === 'bankBSB') {
      const self = this
      if (self.state.typingTimeout) {
        clearTimeout(self.state.typingTimeout)
      }
      // Only trigger bank detail lookup if BSB value is not empty
      if (stateValue.data.value) {
        self.setState({
          searchBank: stateValue.data.value,
          typing: false,
          typingTimeout: setTimeout(() => {
            self.props.handleBankBSB(stateValue.data.value)
          }, 2000),
        })
      }
    }
    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleSelectChange = (name, value, selectedIndex) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
        selectedIndex,
      },
    }

    switch (name) {
      case 'toAccount':
        this.setState({ toAccountSelected: value })
        if (value === constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.ATO) {
          this._handleChange('toAccountName', constants.ACCOUNTSANDLOANS.ATOPAYMENTFORM.TO_ACCOUNT_NAME)
          this._handleChange('toAccountNumber', constants.ACCOUNTSANDLOANS.ATOPAYMENTFORM.TO_ACCOUNT_NO)
          this._handleChange('bankName', constants.ACCOUNTSANDLOANS.ATOPAYMENTFORM.BANK_NAME)
          this._handleChange('bankAddress', constants.ACCOUNTSANDLOANS.ATOPAYMENTFORM.BANK_ADDRESS)
          this._handleChange('bankCity', constants.ACCOUNTSANDLOANS.ATOPAYMENTFORM.BANK_CITY)
          this._handleChange('bankState', constants.ACCOUNTSANDLOANS.ATOPAYMENTFORM.BANK_STATE)
          this._handleChange('bankCountry', constants.ACCOUNTSANDLOANS.ATOPAYMENTFORM.BANK_COUNTRY)
          this._handleChange('bankZip', constants.ACCOUNTSANDLOANS.ATOPAYMENTFORM.BANK_ZIP)
        } else {
          this._handleChange('toAccountName', '')
          this._handleChange('toAccountNumber', '')
          this._handleChange('bankName', '')
          this._handleChange('bankAddress', '')
          this._handleChange('bankCity', '')
          this._handleChange('bankState', '')
          this._handleChange('bankCountry', '')
          this._handleChange('bankZip', '')
        }
        break
      case 'fromAccount': {
        this.setState({ fromAccountSelected: value })
        const amountBalance = this.props.accountsAndLoans.bankTransferAccounts.find(item => item.accountNo === value).balance.toString()
        // INC2000663: The tool will work as a calculator to ensure there is enough balance when partner is submitting an STL request.
        //    The balance will only be there for 24 hours and will be cleared for the next day.
        let totalPendingTransfersToday = 0
        if (this.props.bankTransferForm.bankTransfers && this.props.bankTransferForm.bankTransfers.length > 0) {
          // const bankTransfersToday = this.props.bankTransferForm.bankTransfers.filter(bk => String(bk.FromAccountNo) === String(value) && moment(bk.DateRequested).format('YYYY-MM-DD') >= moment(new Date()).format('YYYY-MM-DD'))
          const bankTransfersToday = this.props.bankTransferForm.bankTransfers.filter(bk => String(bk.FromAccountNo) === String(value) && format(new Date(bk.DateRequested), constants.DATE_FORMAT.STANDARD) >= format(new Date(), constants.DATE_FORMAT.STANDARD))
          if (bankTransfersToday && bankTransfersToday.length > 0) {
            // totalPendingTransfersToday = bankTransfersToday.reduce((transferToday, currentItem) => {(totalPendingTransfersToday = transferToday + currentItem.TotalAmount), 0})
            totalPendingTransfersToday = bankTransfersToday.reduce((transferToday, currentItem) => transferToday + currentItem.TotalAmount, 0)
          }
        }
        this._handleChange('amountFrom', amountBalance - totalPendingTransfersToday)
      }
        break
      default:
        break
    }
    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  canSubmit = () => {
    const form = this.props.forms[this.props.id]
    switch (this.state.toAccountSelected) {
      case constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.ATO:
        return form.fromAccount.value && form.toAccount.value && form.atoEftCodeNo.value
          && form.paygNoticeName.value && form.toAccountName.value && form.toAccountNumber.value
          && form.bankName.value && form.bankAddress.value && form.bankCity.value
          && form.bankState.value && form.bankCountry.value && form.bankZip.value
          && form.amount.value
      case constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.BANK:
        return form.fromAccount.value && form.toAccount.value
          && form.toAccountName.value && form.bankBSB.value
          && form.toAccountNumber.value && form.amount.value
          && (this.props.bankTransferForm.fetched ? this.props.bankTransferForm.bankDetail.BankName : false)
      case constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.CHEQUE:
        return form.fromAccount.value && form.toAccount.value
          && form.payee.value && form.amount.value
      case constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.INTERNAL:
        return form.fromAccount.value && form.toAccount.value
          && form.account.value && form.amount.value
      case constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.OVERSEAS:
        return form.fromAccount.value && form.toAccount.value
          && form.toAccountName.value && form.toAccountNumber.value
          && form.bankName.value && form.bankCity.value
          && form.bankCountry.value && form.amount.value
      default:
        return null
    }
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      title,
      dispatch,
      modals,
      description,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)
    const formHasFetched = this.props.hasFetched
    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id="bankTransferForm"
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          <p className={styles.content}>{description}</p>
          <Alert type="info">
          The cutoff time for same day processing of STL transfers in 12pm.<br />
          Transfers entered after 12pm will be processed on the next business day.
          </Alert>
          {this.props.bankTransferForm.bankTransfers && this.props.bankTransferForm.bankTransfers.length > 0 &&
          <BankTransferList bankTransfers={this.props.bankTransferForm.bankTransfers} />}
          {form &&
          <form
            className={styles.form}
            id={this.props.id}
            noValidate="novalidate"
            onSubmit={this._handleSubmit}
          >
            <div className={styles.sectionHeader} />
            <fieldset>
              <ul>
                <li>
                  <TextInput
                    {...schema.amountFrom}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.amountFrom.value}
                    type="hidden"
                  />
                  <SelectInput
                    {...schema.fromAccount}
                    searchable
                    error={form.fromAccount.error}
                    handleChange={this._handleSelectChange}
                    onBlur={this._handleValidation}
                    options={this.props.accountsAndLoans.bankTransferAccountsOptions} // load from BED?
                    valid={form.fromAccount.valid}
                    value={form.fromAccount.value}
                  />
                </li>
                <li>
                  <SelectInput
                    {...schema.toAccount}
                    error={form.toAccount.error}
                    floatedLabel
                    handleChange={this._handleSelectChange}
                    onBlur={this._handleValidation}
                    options={constants.BANKTRANSFER_LIST_OPTIONS.TRANSFERS} // load from BED?
                    searchable
                    valid={form.toAccount.valid}
                    value={form.toAccount.value}
                  />
                </li>
                { this.state.toAccountSelected === constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.ATO &&
                  <AtoForm
                    form={form}
                    handleChange={this._handleChange}
                    handleFocus={this._handleFocus}
                    handleValidation={this._handleValidation}
                    schema={schema}
                  /> }

                {/* { this.state.toAccountSelected === constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.BANK &&
                  <BankAccountForm
                    bankTransferForm={this.props.bankTransferForm.bankDetail}
                    form={form}
                    handleChange={this._handleChange}
                    handleFocus={this._handleFocus}
                    handleValidation={this._handleValidation}
                    schema={schema}
                  /> } */}

                 { this.state.toAccountSelected === constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.BANK &&
                  <BankToAccountList
                    bankTransferForm={this.props.bankTransferForm.bankDetail}
                    bankTransfers= {this.props.bankTransferForm.bankTransfers}
                    bankAccountsSaved={this.props.bankTransferForm.bankAccounts}
                    form={form}
                    handleChange={this._handleChange}
                    handleFocus={this._handleFocus}
                    handleValidation={this._handleValidation}
                    schema={schema}
                  /> }

                { this.state.toAccountSelected === constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.CHEQUE &&
                  <ChequeForm
                    form={form}
                    handleChange={this._handleChange}
                    handleFocus={this._handleFocus}
                    handleValidation={this._handleValidation}
                    schema={schema}
                  /> }

                { this.state.toAccountSelected === constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.INTERNAL &&
                  <InternalDttForm
                    bankTransferAccountsOptions={this.props.accountsAndLoans.bankTransferAccountsOptions.filter(accounts => accounts.value !== this.state.fromAccountSelected)}
                    form={form}
                    handleChange={this._handleChange}
                    handleFocus={this._handleFocus}
                    handleSelectChange={this._handleSelectChange}
                    handleValidation={this._handleValidation}
                    schema={schema}
                  /> }

                { this.state.toAccountSelected === constants.ACCOUNTSANDLOANS.TRANSFER_TYPE.OVERSEAS &&
                  <OverseasForm
                    form={form}
                    handleChange={this._handleChange}
                    handleFocus={this._handleFocus}
                    handleValidation={this._handleValidation}
                    schema={schema}
                  /> }

              </ul>
            </fieldset>
            <br /><br />
            <div className={styles.footer}>
              <SubmitButton
                complete={this.props.forms[this.props.id]._isComplete}
                completeText={completeText} // Add validation rules
                disabled={!this.canSubmit()}
                isLarge
                submitting={this.props.forms[this.props.id]._isPosting}
                submittingText={submittingText}
              >
                {ctaText}
              </SubmitButton>
            </div>
          </form>
        }
        </div>
      </Modal>
    )
  }
}

export default BankTransferDisplayForm



// WEBPACK FOOTER //
// ./src/views/AccountsAndLoans/BankTransferDisplayForm.js